import { client } from '../client';
import { IGMConversation } from './types/IGMConversation';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface ParticipantPayload {
  identity: string;
}

export const addConversationParticipant = async (
  payload: ParticipantPayload,
  conversation_sid: string,
  userRole?: string,
): Promise<IGMConversation> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<IGMConversation>(
    `${prefix}/conversations/${conversation_sid}/participants`,
    payload,
  );

  return data;
};
